var map = {
	"./main/customForm": 49583,
	"./main/customForm/": 49583,
	"./main/customForm/index": 49583,
	"./main/customForm/index.ts": 49583,
	"./main/management": 52345,
	"./main/management/": 52345,
	"./main/management/index": 52345,
	"./main/management/index.ts": 52345,
	"./main/resources": 63803,
	"./main/resources/": 63803,
	"./main/resources/index": 63803,
	"./main/resources/index.ts": 63803,
	"./main/simulation": 18557,
	"./main/simulation/": 18557,
	"./main/simulation/index": 18557,
	"./main/simulation/index.ts": 18557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90189;